import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle2, XCircle, Loader2, Mail } from 'lucide-react';
import api, { formatApiError } from '../lib/api';

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('No verification token provided.'); return; }
    api.post('/auth/verify-email', { token })
      .then(({ data }) => { setStatus('success'); setMessage(data.message); })
      .catch(err => { setStatus('error'); setMessage(formatApiError(err.response?.data?.detail)); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-page-bg px-4">
      <div className="w-full max-w-md text-center">
        <div className="glass-panel p-8" data-testid="verify-email-card">
          {status === 'loading' && (
            <>
              <Loader2 className="w-12 h-12 text-brand-orange mx-auto mb-4 animate-spin" />
              <h2 className="font-display text-2xl font-extrabold text-ink mb-2">Confirming your account…</h2>
              <p className="font-body text-sm text-ink/50">Please wait while we verify your email address.</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle2 className="w-14 h-14 text-status-green mx-auto mb-4" strokeWidth={1.5} />
              <h2 className="font-display text-2xl font-extrabold text-ink mb-2">Email Confirmed</h2>
              <p className="font-body text-sm text-ink/50 mb-6">{message || 'Your email has been verified. You can now sign in to access the Stockton Digital Register.'}</p>
              <Button onClick={() => navigate('/login')} className="bg-brand-orange text-white hover:bg-brand-orange/90 font-body rounded-[4px]" data-testid="verify-continue">
                Continue to Sign In
              </Button>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-14 h-14 text-status-red mx-auto mb-4" strokeWidth={1.5} />
              <h2 className="font-display text-2xl font-extrabold text-ink mb-2">Verification Link Invalid or Expired</h2>
              <p className="font-body text-sm text-ink/50 mb-6">{message}{message && !message.endsWith('.') ? '.' : ''} Please sign in and request a new verification link from the dashboard, or contact your administrator.</p>
              <Link to="/login" className="font-body text-sm text-brand-orange underline">Back to Sign In</Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
